import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { A } from '@adornis/base/env-info.js';

@Entity()
export class PartnerSchedulingPartner extends MongoEntity {
  static override _class = 'PartnerSchedulingPartner';
  static override _collectionName = 'partner-scheduling-partners';

  static override resolveID(_entity: PartnerSchedulingPartner): string {
    return (_entity._id ??= A.getGloballyUniqueID());
  }

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  override _id!: string;

  @Field(() => String)
  partnerName: Maybe<string>;

  @Field(() => String)
  contactName: Maybe<string>;

  @Field(() => String)
  contactEmail: Maybe<string>;

  @Field(() => String)
  contactPhone: Maybe<string>;
}
